// extracted by mini-css-extract-plugin
export default {"header":"_1xy4z","wrapper":"_1LKno","headerWrapper":"_3UHi5","sectionReplay":"xRJHe","direct":"USpNr","replay":"_2hrhv","iphone":"_1zW1U"};